<!-- 移动端股东人数图表展示组件 -->
<template>
	<div v-if="chartData.length" class="chart-wrapper">
		<MobileLineBar
			:chartOptions="{
				grid: { top: 16 },
				legend: { show: false }
			}"
			:timeFormatter="timeFormatter"
			:seriesData="chartData"
			:tooltip-label="$t('enterprise.total-of-holdings')"
			:legends="[$t('enterprise.total-of-holdings')]"
		/>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import MobileLineBar from '@/components/mobile/MobileLineBar.vue';
import i18n from '@/locales';

// Props 定义
const props = defineProps({
	// 股东数据
	data: {
		type: Array,
		default: () => []
	},
	// 显示的数据条数
	maxItems: {
		type: Number,
		default: 5
	}
});

// 图表数据处理
const chartData = computed(() => {
	const seenDates = new Set();
	const data = [...props.data];
	const sortedAndUniqueData = data
		.slice(0, props.maxItems)
		.sort((a, b) => new Date(a.date) - new Date(b.date))
		.filter(item => {
			if (!seenDates.has(item.date)) {
				seenDates.add(item.date);
				return true;
			}
			return false;
		})
		.map(item => [item.date, item.totalAccount]);

	return [
		{
			type: 'bar',
			data: sortedAndUniqueData,
			name: i18n.t('enterprise.total-of-holdings')
		}
	];
});

// 移动端时间格式化器
const timeFormatter = value => {
	let arr = value.split('-');
	let target = `${arr[1]}-${arr[2]}` + '\n' + `${arr[0]}`;
	return target;
};
</script>

<style lang="less" scoped>
.chart-wrapper {
	width: 100%;
	height: 246px;
}
</style>
